


















import {Vue, Component, Prop} from 'vue-property-decorator';
import CompanySearch from "@/components/common/CompanySearch.vue";
import {CreateSt120Payload} from "@/dto/archive/ST120Payloads";
import CompanyDTO from "@/dto/company/CompanyDTO";
import Notifications from "@/state/Notifications";
import Application from "@/state/Application";
import DocumentService from "@/services/DocumentService";
import {processError} from "@/utils/ComponentUtils";

@Component({
	components: {CompanySearch}
})
export default class ST120CreationModal extends Vue {

	private req = new CreateSt120Payload()

	@Prop()
	private callBack!: (documentId: number) => void

	private filterApply(company: {email: string | null, companyName: string | null} | null) {
		if (company) {
			this.req.seller.name = company.companyName
			this.req.seller.email = company.email
		}
	}

	private applySeller(company: CompanyDTO | null) {
		if (company) {
			this.req.seller.companyId = company.id
			this.req.seller.name = company.name
			this.req.seller.email = company.email
		} else {
			this.req.seller.companyId = null
			this.req.seller.email = null
			this.req.seller.name = null
		}
	}

	private create() {
		const seller = this.req.seller
		if (
			this.req.seller.companyId == null
			&& (seller.email == null || seller.email == "")
			&& (seller.name == null || seller.name == "")
		) {
			Notifications.error("Choose or type seller's info")
			return
		}
		Application.startLoading()
		this.req.purchaserId = this.$wss.getCurrent.id
		DocumentService.registerST120(this.req).then(
			res => {
				Application.stopLoading();
				this.callBack(res.data.id)
				this.$modal.hideAll()
			},
			err => processError(err, this)
		)
	}

}
